/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Container } from '@material-ui/core';
import { ContainerProps } from '@material-ui/core/Container';

import { mergeLeft } from 'ramda';
import { composeStyles } from 'features/Theme';

import styles from './styles';

type PropTypes = Pick<ContainerProps, 'maxWidth'> & {
  className?: string;
  /**
   * Default to true. Borders are not displayed when embedded
   */
  bordered?: boolean;
};

const defaultProps: Partial<PropTypes> = {
  bordered: true,
};

const PageContainer: React.FC<PropTypes> = props => {
  props = mergeLeft(props, defaultProps);

  const { maxWidth, bordered, className, children } = props;

  return (
    <Container maxWidth={maxWidth || 'md'}>
      <div
        css={composeStyles([styles.pageContainer, bordered && styles.bordered])}
        className={className}
      >
        {children}
      </div>
    </Container>
  );
};

export default PageContainer;
